import React from "react";
import { ACTIVE_STATUS } from "shared/constants/obu";
import { useStyles } from "./styles";
import { Badge } from "e100-react-components";
interface LocationStatusProps {
  status: ACTIVE_STATUS;
}

export const LocationStatusIcon = ({ status }: LocationStatusProps) => {
  const classes = useStyles();
  switch (status) {
    case ACTIVE_STATUS.FROM_0_TO_4_HOURS:
      return <Badge variant="dot" color="primary" />;
    case ACTIVE_STATUS.FROM_4_TO_10_HOURS:
      return <Badge variant="dot" classes={{ badge: classes.badgeColor }} />;
    case ACTIVE_STATUS.MORE_10:
      return <Badge variant="dot" color="error" />;
    default:
      return null;
  }
};
